/* tslint:disable */
/* eslint-disable */
// this is an auto generated file. This will be overwritten

import * as APITypes from "./api";
type GeneratedQuery<InputType, OutputType> = string & {
  __generatedQueryInput: InputType;
  __generatedQueryOutput: OutputType;
};

export const getBondedQuantitiesByDocumentIds = /* GraphQL */ `query GetBondedQuantitiesByDocumentIds($documentIds: [String!]!) {
  getBondedQuantitiesByDocumentIds(documentIds: $documentIds) {
    documentId
    totalBondedQuantity
    __typename
  }
}
` as GeneratedQuery<
  APITypes.GetBondedQuantitiesByDocumentIdsQueryVariables,
  APITypes.GetBondedQuantitiesByDocumentIdsQuery
>;
